:host {
  display: flex;
  gap: 10px;
}

span {
  display: none;
  color: var(--color-white);

  &.show {
    display: block;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}
